import { readonly, ref } from 'vue'

const isReportListingUpdated = ref(false)

export const useReportListing = (): any => {
  const setUpdateReportListing = (isUpdated: boolean) => {
    isReportListingUpdated.value = isUpdated
  }

  return {
    isReportListingUpdated: readonly(isReportListingUpdated),
    setUpdateReportListing,
  }
}
